import axios from "axios";
import {
  getHeaders,
  checkStatus,
} from "../../../../Services/SharedSevices/SharedServices";
import axiosInstance from "../../../../Services/Global-Services/UnauthorizedTokenHandler";
const baseURL = process.env.REACT_APP_BASE_URL;

// For adding the record of Academics service.

export const employeeAcademics = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Employee/Academic`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const addEmployeeAcademics = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Employee/Academic/Add`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

// For deleting the record of Academics service.
export const deleteEmployeeAcademics = async (body) => {
  try {
    const response = await axiosInstance.delete(`${baseURL}/Employee/Academic/Delete`,{
      headers: await getHeaders(),
      data: body,
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

// For adding the record of Appreciation service.

export const employeeAppreciation = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Employee/Appreciation`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}


export const addEmployeeAppreciation = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Employee/Appreciation/Add`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

// For deleting the record of Academics service.

export const deleteEmployeeAppreciations = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Employee/Appreciation/Delete`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

  // expriences list data 

  export const getEmployeeExpriences = async (body) => {
    try {
      const response = await axiosInstance.post(`${baseURL}/Employee/Expriences`, body, {
        headers: await getHeaders(),
        body: JSON.stringify(body)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

// For adding the record of Experience service.

export const addEmployeeExperience = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Employee/Experience/Add`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

// For deleting the record of Experience service.

export const deleteEmployeeExperience = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Employee/Experience/Delete`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

  // For adding the record of Skills service.

  export const employeeSkills = async (body) => {
    try {
      const response = await axiosInstance.post(`${baseURL}/Employee/Skills`, body, {
        headers: await getHeaders(),
        body: JSON.stringify(body)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  export const addEmployeeSkills = async (body) => {
    try {
      const response = await axiosInstance.post(`${baseURL}/Employee/Skills/Add`, body, {
        headers: await getHeaders(),
        body: JSON.stringify(body)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

    // For adding the record of Language service.

    export const employeeLanguage = async (body) => {
      try {
        const response = await axiosInstance.post(`${baseURL}/Employee/Language`, body, {
          headers: await getHeaders(),
          body: JSON.stringify(body)
        });
        checkStatus(response);
        return response.data;
      } catch (error) {
        return Promise.reject(error);
      }
    }


    export const addEmployeeLanguage = async (body) => {
      try {
        const response = await axiosInstance.post(`${baseURL}/Employee/Languages/Add`, body, {
          headers: await getHeaders(),
          body: JSON.stringify(body)
        });
        checkStatus(response);
        return response.data;
      } catch (error) {
        return Promise.reject(error);
      }
    }

// For deleting the record of Language service.

export const deleteEmployeeLanguage = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Employee/Languages/Delete`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

  // For deleting the record of Language service.

  export const deleteEmployeeSkills = async (body) => {
    try {
      const response = await axiosInstance.post(`${baseURL}/Employee/Skills/Delete`, body, {
        headers: await getHeaders(),
        body: JSON.stringify(body)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }


  //For add project of working employee .

  export const getEmployeeAddProject = async (body) => {
    try {
      const response = await axiosInstance.post(`${baseURL}/OrgProject/Project`, body, {
        headers: await getHeaders(),
        body: JSON.stringify(body)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  // badges List data
  
  export async function getEmployeeBadge(params) {
    try {
      const response = await axiosInstance.post(`${baseURL}/Employee/Badge`, params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    }catch(error){
      return Promise.reject(error);
    }    
  }

    
  export async function addEmployeeBadge(params) {
    try {
      const response = await axiosInstance.post(`${baseURL}/Employee/Badge/Add`, params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    }catch(error){
      return Promise.reject(error);
    }    
  }

  export async function deleteEmployeeBadge(params) {
    try {
      const response = await axiosInstance.delete(`${baseURL}/Employee/Badges/Delete`,{
        headers: await getHeaders(),
        data: params
      });
      checkStatus(response);
      return response.data;
    }catch(error){
      return Promise.reject(error);
    }    
  }


  export const getOrgBadge = async (params) => {
    try {
      const response = await axiosInstance.get(`${baseURL}/Org/OrgBadge?OrgId=${params.OrgId}`, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

   export async function deleteSocial(params) {
    try {
      const response = await axiosInstance.delete(`${baseURL}/Employee/Social/Delete`,{
        headers: await getHeaders(),
        data: params
      });
      checkStatus(response);
      return response.data;
    }catch(error){
      return Promise.reject(error);
    }    
  }
  
//Get Certificate
  export const getEmployeeCertificate = async (body) => {
    try {
      const response = await axiosInstance.post(`${baseURL}/Employee/Certificate`, body, {
        headers: await getHeaders(),
        body: JSON.stringify(body)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

//Add Certificate
  export const addEmployeeCertificate = async (body) => {
    try {
      const response = await axiosInstance.post(`${baseURL}/Employee/Certificate/Add`, body, {
        headers: await getHeaders(),
        body: JSON.stringify(body)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

//Delete Certificate
  export const deleteEmployeeCertificate = async (params) => {
    try {
      const response = await axiosInstance.delete(`${baseURL}/Employee/Certificate/Delete`, {
        headers: await getHeaders(),
        data: params,
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  export const deleteEmployeeAccount = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Employee/Delete`, params, {
         headers: await getHeaders() 
        });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

  //Add Award
  export const addOrgAwardsAward = async (params) => {  
    try {
      const response = await axiosInstance.post(`${baseURL}/Org/OrgAwards/Add`, params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  //delete Award
  export const deleteOrgAwards = async (body) => {
    try {
      const response = await axiosInstance.delete(`${baseURL}/Org/OrgAwards/Delete`, {
        headers: await getHeaders(),
        data: body,
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  // Organization level 

  export const addOrgProject = async (params) => {
    try {
      const response = await axiosInstance.post(`${baseURL}/OrgProject/Add`, params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  export const getOrgProject = async (params) => {
    try {
      const response = await axiosInstance.get(`${baseURL}/OrgProject/Get?ProjectId=${params.ProjectId}&OrgId=${params.OrgId}`, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  // Assign project  to Employee

  export const addProjectAssignes = async (params) => {
    try {
      const response = await axiosInstance.post(`${baseURL}/OrgProject/ProjectAssignes/Add`, params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }


  export const getProjectAssignes = async (params) => {
    try {
      const response = await axiosInstance.get(`${baseURL}/OrgProject/ProjectAssignes`, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  export const getFollowerList = async (params) => {
    try {
      const response = await axiosInstance.get(`${baseURL}/Employee/FollowerList?EmpId=${params.EmpId}`, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  export const UpdateEmpDetail = async (params) => {
    try {
      const response = await axiosInstance.post(`${baseURL}/Employee/UpdateEmpDetailsAll`, params,{
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  // Edit Profile

  export const updateEmployee = async (params) => {
    try {
      const response = await axiosInstance.post(`${baseURL}/Employee/Restricted/Update`, params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

    // Edit Profile

    export const addUpdateEmployeeKeyValue = async (params) => {
      try {
        const response = await axiosInstance.post(`${baseURL}/Employee/Update`, params, {
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
        checkStatus(response);
        return response.data;
      } catch (error) {
        return Promise.reject(error);
      }
    }

   // add/edit employee address

  export const addEmployeeAddress = async (params) => {
    try {
      const response = await axiosInstance.post(`${baseURL}/Employee/Address/Add`, params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  // employee Adress

   export const getEmployeeAddress = async (params) => {
    try {
      const response = await axiosInstance.post(`${baseURL}/Employee/Address`,params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  // delete Address 

  export const deleteEmployeeAddress = async (body) => {
    try {
      const response = await axiosInstance.delete(`${baseURL}/Employee/Address/Delete`, {
        headers: await getHeaders(),
        data: body,
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

//  Dashboard Count Summary.
    export const getEmployeeSummary = async (params) => {
    try {
      const response = await axiosInstance.post(`${baseURL}/Employee/Summary`, params,{
        headers: await getHeaders(),
        body: JSON.stringify()
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

    export const UpdateOfficialEmail = async (params) => {
    try {
      const response = await axiosInstance.post(`${baseURL}/Employee/OfficialEmail/Update`, params,{
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

   export const addSocialMedia = async (params) => {
    try {
      const response = await axiosInstance.post(`${baseURL}/Employee/Social/Add`, params,{
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  // Organisation badges setting

  export const getOrganizationBadges = async (params) => {
    try {
        const response = await axiosInstance.get(`${baseURL}/Org/OrgBadges/GetAllOrgBadges`, {
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
        checkStatus(response);
        return response.data;
      } catch (error) {
        return Promise.reject(error);
      }
  }

  // Organisation Badges setting Add/Update
 
  export const addOrganizationBadges = async (params) => {
    try {
      const response = await axiosInstance.post(
        `${baseURL}/Org/OrgBadges/Add`,params,{
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
      
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  // Organisation Badges setting Delete

  export const deleteOrganizationBadges = async (params) => {
  try {
    const response = await axiosInstance.delete(
      `${baseURL}/Org/OrgBadges/Delete`,
      {
        headers: await getHeaders(),
        data: params 
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};